import React, { useEffect, useState } from "react";
// import AllButton from "../../components/button/AllButton";
import VerticalCard from "../../components/card/VerticalCard";
import PageBanner from "../../components/PageBanner";
import NewsService from "../../services/news";
import BannerService from "../../services/banner";
import Pagination from "../../components/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCalendar } from "@fortawesome/free-solid-svg-icons";
import Datepicker from "react-tailwindcss-datepicker";
import { useParams } from "react-router-dom";
import { newsSize } from "../../configs/pageSize";

export default function NewsAll() {
  let [newsData, setNewsData] = useState([]);
  let [meta, setMeta] = useState({});
  let [newsBanner, setNewsBanner] = useState([]);

  let { lang } = useParams();

  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [pageSize, setPageSize] = useState(newsSize);
  const [keyword, setKeyword] = useState("");
  // eslint-disable-next-line
  const [sort, setSort] = useState("desc");
  const [date, setDate] = useState({
    startDate: new Date(
      new Date().getFullYear() - 4,
      new Date().getMonth(),
      new Date().getDate()
    )
      .toISOString()
      .slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
  });

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getNewsBanner();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getNewsData();

    // eslint-disable-next-line
  }, [keyword, date, sort, page, pageSize]);

  const getNewsData = async () => {
    try {
      let [res, meta] = await NewsService.getNews({
        ...(keyword && { keyword: keyword }),
        startDate: date.startDate,
        endDate: date.endDate,
        sort: sort,
        page: page,
        pageSize: pageSize,
      });
      setNewsData(res);
      setMeta(meta);
    } catch {
      console.error();
    }
  };

  const getNewsBanner = async () => {
    try {
      let res = await BannerService.getBanner(2);
      setNewsBanner(res);
    } catch {
      console.error();
    }
  };

  const handleDateChange = (newValue) => {
    setDate(newValue);
  };

  const handleKeywordChange = (newKeyword) => {
    setKeyword(newKeyword);
    // getNewsData();
  };

  const bannerText = [
    { name: "News and Activity", href: "/newsAndActivity" },
    {
      name: "news",
    },
  ];

  return (
    <div id="news-all" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"รวมข่าวสาร"}
        text_en={"News"}
        banner={newsBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* ข่าวสาร */}
          <div id="news-section" className="pt-[92px] pb-[48px]">
            <div className="mb-[40px]">
              <h1 className="text-left text-subheading font-bold inline-block border-b-[2px] border-lightGray pb-[5px]">
                {lang === "th" ? "ข่าวสาร" : "News"}
              </h1>
            </div>

            <div className="my-[20px] flex flex-col lg:flex-row items-center justify-start gap-[20px]">
              <div className="relative w-full lg:w-auto flex-[2]">
                <input
                  defaultValue={keyword}
                  onChange={(e) => handleKeywordChange(e.target.value)}
                  placeholder={
                    lang === "th" ? "ค้นหาจาก Keyword" : "Finding by Keyword"
                  }
                  className="w-full font-normal text-meta py-[11px] px-[23px] border-[1px] border-darkGray rounded-[8px]"
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  className="text-body cursor-pointer absolute text-darkGray top-[14px] right-[15px] pointer-events-none"
                />
              </div>
              
              <div className="flex flex-col lg:flex-row items-center justify-start gap-[20px] w-full lg:w-auto flex-[3]">
                <div className="flex items-center gap-[10px] w-full lg:w-auto flex-1">
                  <h1 className="text-meta whitespace-nowrap">
                    {lang === "th" ? "ช่วงเวลา" : "Time Range"}
                  </h1>
                  <div className="date-picker relative w-full border-[1px] border-darkGray rounded-[8px]">
                    <Datepicker value={date} onChange={handleDateChange} />
                    <FontAwesomeIcon
                      icon={faCalendar}
                      className="text-body cursor-pointer absolute text-darkGray top-[12px] left-[15px] pointer-events-none"
                    />
                  </div>
                </div>
                
                <div className="flex items-center gap-[10px] w-full lg:w-auto flex-1">
                  <h1 className="text-meta whitespace-nowrap">
                    {lang === "th" ? "เรียงลำดับ" : "Sort By"}
                  </h1>
                  <select
                    name="ordering"
                    className="w-full font-normal text-meta py-[11px] px-[23px] border-[1px] border-darkGray rounded-[8px]"
                    value={sort}
                    onChange={(event) => setSort(event.target.value)}
                  >
                    <option value="desc">
                      {lang === "th" ? "ล่าสุด - เก่าสุด" : "Latest to Oldest"}
                    </option>
                    <option value="asc">
                      {lang === "th" ? "เก่าสุด - ล่าสุด" : "Oldest to Lastest"}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px] mt-[40px]">
              {newsData &&
                newsData.map((item, i) => (
                  <VerticalCard
                    data={item}
                    key={i}
                    page="newsAndActivity/news"
                    lang={lang}
                  />
                ))}
            </div>

            {newsData && newsData.length <= 0 && (
              <p className="text-lead text-center mt-[40px]">
                {lang === "th"
                  ? "ไม่พบข้อมูลที่ค้นหา..."
                  : "Not found any news ..."}
              </p>
            )}

            {newsData && (
              <Pagination
                length={meta?.pagination?.pageCount ?? ""}
                selected={page}
                function={(i) => setPage(i)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
